import { ReactElement } from 'react';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitAndAppointmentStatusFilterStorage } from '../AppointmentsFilterPanel/fields/VisitAndAppointmentStatusField/VisitAndAppointmentStatusField.storage';
import { useAppointmentsFiltersContext } from '../AppointmentFilter.context';

import { ChipFilter } from './ChipFilter';
import { useVisitAndAppointmentStatusFilterLabel } from './VisitAndAppointmentStatusChipFilter.hooks';

export const VisitAndAppointmentStatusChipFilter = (): ReactElement | null => {
   const { getFilter } = useAppointmentsFiltersContext();

   const visitAndAppointmentStatuses = getFilter('visitAndAppointmentStatus');
   const label = useVisitAndAppointmentStatusFilterLabel(visitAndAppointmentStatuses);

   if (!visitAndAppointmentStatuses.length) {
      return null;
   }
   return (
      <ChipFilter
         label={label}
         searchParamKey={visitPaths.VISIT_AND_APPOINTMENT_STATUS_SEARCH_PARAM}
         testId={'visitAndAppointmentsStatusFilter'}
         onClick={visitAndAppointmentStatusFilterStorage.removeFilter}
      />
   );
};
